<template>
	<div class="form">
		<div class="form__head">
			<h1 class="form__title text-5xl">{{ formTitle }}</h1>
		</div>

		<div class="form__main">
			<form
				v-if="!getState.isRequestSent"
				class="form-login form__form">
				<form-group
					:label-text="'Логин или e-mail'"
					:label-for="'login'"
					:class-label="'text-xl'">
					<InputText
						id="login"
						v-model="getState.email"
						:placeholder="'Введите ваш логин или e-mail'" />
				</form-group>

				<Button
					class="form__button-action"
					label="Восстановить пароль"
					:disabled="!passwordResetFormHandler.isEmailFormatValid"
					@click="passwordResetRepository.sendPasswordResetRequest()" />
			</form>

			<template v-else>
				<Message
					class="form__message"
					:severity="getState.result.success ? 'success' : 'error'"
					:closable="false">
					<div class="message__wrapper">
						<h2 class="message__title">{{ getState.result.success ? "Успешно" : "Ошибка" }}</h2>

						<p class="message__desc">{{ getState.result.message }}</p>
					</div>
				</Message>

				<Button
					v-if="!getState.result.success"
					class="text-xl"
					label="Попробовать ещё раз"
					@click="passwordResetRepository.retryRequest()" />
			</template>
		</div>

		<div class="form__footer">
			<router-link to="/login">
				<Button
					class="text-xl"
					label="Вернуться к входу"
					icon="pi pi-arrow-left"
					link />
			</router-link>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { PasswordResetFormHandler } from "@/assets/ts/models/password-reset-form/PasswordResetFormHandler";
	import { PasswordResetRepository } from "@/assets/ts/models/password-reset-form/PasswordResetRepository";
	import { PageTitles } from "@/assets/ts/enums/PageTitles";

	const formTitle = ref(PageTitles.PasswordRecovery);

	const passwordResetFormHandler = new PasswordResetFormHandler();
	const passwordResetRepository = new PasswordResetRepository(passwordResetFormHandler);

	const { getState } = passwordResetRepository;
</script>

<style scoped lang="scss">
	@import "form";
</style>
